import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiSend, FiMessageCircle } from "react-icons/fi";
import { FaTiktok, FaFacebook } from "react-icons/fa";

const TIKTOK_URL = "https://www.tiktok.com/@_buyit.ng?is_from_webapp=1&sender_device=pc";
const FACEBOOK_URL = "https://web.facebook.com/profile.php?id=61582583862200";

const CustomerCareScreen = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Can I Pay On Delivery",
      answer:
        "Yes, you can pay on delivery on BUY iT by choosing the Pay On Delivery option. You will pay for your product when it is delivered to you.",
      maxHeight: "max-h-40",
    },
    {
      question: "How do I receive my product first before I pay for it.",
      answer:
        "Once you place an order and pay for the product, your money is held safely in BUY iT escrow account. You will see the money there and receive a confirm code. When your product is delivered, you confirm delivery using your code. After that, the payment is released to the vendor.",
      maxHeight: "max-h-60",
      bordered: true,
    },
    {
      question: "Is my payment safe after I pay for a product?",
      answer:
        "Yes, your payment is safe. Your money stays in BUY iT escrow account and will only be released to the vendor after you confirm that your product has been delivered.",
      maxHeight: "max-h-40",
    },
  ];

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 pb-10">
      <header className="sticky top-0 z-10 bg-white shadow-sm">
        <div className="flex items-center p-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="h-10 w-10 flex items-center justify-center"
            aria-label="Go back"
          >
            <FiArrowLeft className="h-5 w-5 text-gray-800" />
          </button>
          <h1 className="flex-1 text-center text-base font-semibold text-gray-900">
            Customer Care
          </h1>
          <div className="h-10 w-10" />
        </div>
      </header>

      <p className="text-center text-sm text-gray-600 mt-4 px-4">
        Having an issue? Message our support team
      </p>

      <div className="mt-4 px-4 space-y-3">
        <div
          className="bg-white rounded-xl p-4 shadow-sm flex items-center gap-3 cursor-pointer"
          onClick={() => {
            window.location.href =
              "https://wa.me/2347078145852?text=Hello%20BUY%20iT%20team👋,%20I%20am%20having%20a%20problem%20using%20BUY%20iT,%20I%27ll%20love%20it%20to%20be%20resolved%20now.%20Thank%20you.";
          }}
        >
          <FiSend className="h-5 w-5 text-[#000000]" />
          <span className="text-sm font-semibold text-gray-900">Send us a message</span>
        </div>
        <div
          className="bg-white rounded-xl p-4 shadow-sm flex items-center gap-3 cursor-pointer"
          onClick={() => {
            window.location.href = "https://wa.me/2347078145852";
          }}
        >
          <FiMessageCircle className="h-5 w-5 text-black" />
          <span className="text-sm font-semibold text-gray-900">Messages</span>
        </div>
      </div>

      <div className="mt-6 px-4">
        <h2 className="text-base font-semibold text-gray-900">FAQs</h2>
        <div className="mt-4 space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.question} className="bg-white rounded-xl p-4 shadow-sm">
                <button
                  type="button"
                  onClick={() => handleToggle(index)}
                  className={`w-full text-left text-sm font-semibold text-gray-900 ${
                    faq.bordered ? "border-b border-[#AAAAAA] pb-3" : ""
                  }`}
                >
                  {faq.question}
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? faq.maxHeight + " opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="pt-3 text-sm text-gray-700">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-6 px-4">
        <p className="text-sm text-gray-700">
          Follow us on our social media pages to get updates and tips to boost your store sales on BUY iT.
        </p>
        <div className="mt-4 flex items-center justify-between">
          <button
            type="button"
            onClick={() => window.open(TIKTOK_URL, "_blank")}
            className="flex flex-col items-center gap-1"
          >
            <FaTiktok className="text-2xl text-black" />
            <span className="text-xs text-gray-700">TikTok</span>
          </button>
          <button
            type="button"
            onClick={() => window.open(FACEBOOK_URL, "_blank")}
            className="flex flex-col items-center gap-1"
          >
            <FaFacebook className="text-2xl text-black" />
            <span className="text-xs text-gray-700">Facebook</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerCareScreen;
